export default "__VITE_ASSET__SB3MTcJp__"